module.exports = __webpack_public_path__ + "img/cover-3.9c2f8e02.png";